import { reconcileIncomingSsoSession } from "store/auth/auth.utils"

// Runs at module load, before the Redux store's `initialState` reads
// `localStorage`. Imported first in `index.tsx` so a stale local session is
// cleared before the store initialises — the store then starts with no auth
// data and `<UnauthRoutes/>` renders the SSO loader that consumes the cookie.
export const ssoReconciled = reconcileIncomingSsoSession()
